export default {"src":"/_next/static/media/roadwise-financing-logo-dark-fr.72170601.svg","height":46,"width":109,"blurWidth":0,"blurHeight":0};